
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-61da983c&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditWrittenRoundTable.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditWrittenRoundTable.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-61da983c!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditWrittenRoundTable.vue"),
  /* scopeId */
  "data-v-61da983c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/WrittenRoundtables/Dialogs/EditWrittenRoundTable.vue
// module id = 254
// module chunks = 61